import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-right: ", ";\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { ICON_SIZE } from '../../constants';
import { getIconColor, getIconHoverColor } from '../../helpers/icons';
import SvgIcon from '../../SvgIcon';
import styled from 'styled-components';
import { getPx } from '../../helpers';
import { INPUT_HORIZONTAL_PADDING } from '../constants';
var StyledIndicatorIcon = styled(SvgIcon)(_templateObject(), getPx(INPUT_HORIZONTAL_PADDING), function (_ref) {
  var open = _ref.open;
  return open && "\n    svg {\n      transform: rotate(180deg);\n    }\n  ";
});
var DropdownIndicatorIcon = /*#__PURE__*/React.forwardRef(function (_ref2, forwardedRef) {
  var isDisabled = _ref2.isDisabled,
      isRotated = _ref2.isRotated,
      icon = _ref2.icon,
      props = _objectWithoutPropertiesLoose(_ref2, ["isDisabled", "isRotated", "icon"]);

  return /*#__PURE__*/React.createElement(StyledIndicatorIcon, _extends({
    ref: forwardedRef,
    pointer: !isDisabled,
    color: getIconColor(isDisabled),
    colorHover: getIconHoverColor(isDisabled),
    size: ICON_SIZE,
    open: isRotated
  }, props), icon);
});
export default DropdownIndicatorIcon;